import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { StorageEnums } from 'src/shared/models/enums';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { StorageService } from '../services/storage.service';


@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(private storage: StorageService,
				private helpService: HelperService,
				private router: Router) {
	}

	async canActivate(route: ActivatedRouteSnapshot) {
		const skipAuth = route.data.skipAuth || false;
		const goToLogin = route.data.goToLogin;
		let serverApiVersion = await this.storage.getItem(StorageEnums.MIN_SERVER_API_VERSION);
		let appVersion = await this.storage.getItem(StorageEnums.APP_VERSION);

		let checkings = async () => {
			let isVersionCompatible;
			// console.log('canActivate', serverApiVersion, appVersion);
			if (serverApiVersion) {
				isVersionCompatible = await this.helpService.isAppVersionInvalid(serverApiVersion, appVersion);
			} else {
				isVersionCompatible = await this.helpService.isAppVersionInvalid(appVersion, appVersion);
			}
			let userLoggedIn = await this.storage.getItem(StorageEnums.USER_LOGGED_IN);
			let authT = await this.storage.getItem(StorageEnums.AUTH_TOKEN) === null;
			let refreshT = await this.storage.getItem(StorageEnums.REFRESH_TOKEN) === null;
			let needLogIn = authT && refreshT || !userLoggedIn;

			if (isVersionCompatible) {
				return await this.router.navigate(['app-version'])
			}

			if(needLogIn && goToLogin) {
				return await this.router.navigate(['auth']);
			}

			if (!skipAuth) {
				return !needLogIn ? true : await this.router.navigate(['home']);
			}

			if (skipAuth && !needLogIn) {
				return await this.router.navigate(['home']);
			}
			return true;
		}
		return await checkings();
	}

}
